import React, { FC } from "react";
import Box from "@mui/material/Box";
import { visuallyHidden } from "@mui/utils";
import { StyledComponent } from "styled-components";

// Define the props for the HOC
export interface WithVisuallyHiddenProps {
  hiddenText?: string;
  children?: React.ReactNode;
  [key: string]: any
}

// Higher-Order Component to add visually hidden text
const withVisuallyHidden = (
  Component: React.ComponentType | StyledComponent<React.ComponentType, {}>
): FC<WithVisuallyHiddenProps> => {
  const WrappedComponent: FC<WithVisuallyHiddenProps> = ({
    hiddenText,
    children,
    ...restProps
  }) => (
    <Component {...(restProps)}>
      {children}
      {hiddenText && <Box sx={visuallyHidden}>{hiddenText}</Box>}
    </Component>
  );
  return WrappedComponent;
};

export default withVisuallyHidden;
